import React from "react";
// import "../../assets/css/product-list.css";

const ProductFilterCard = ({ ProductImg, ProductPrice }) => {
  return (
    <>
      <div className="customfilter d-none d-md-block d-lg-block product-custom-filter">
        <h4 className="d-flex align-items-center">
          <img
            src="data:image/png;base64,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"
            className="pe-2"
          />{" "}
          Variant
        </h4>
        <div className="accordion pt-2 pe-5" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingsize">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOnesize"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                Display Size <span className="tempLabel" />
              </button>
            </h2>
            <div
              id="collapseOnesize"
              className="accordion-collapse"
              aria-labelledby="headingsize"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="address_row_name">
                  <input className="form-radio" type="radio" name="size" />
                  <label />
                  <span className="name"> 6.1-inch</span>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingcolor">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOnecolor"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                Color <span className="tempLabel" />
              </button>
            </h2>
            <div
              id="collapseOnecolor"
              className="accordion-collapse"
              aria-labelledby="headingcolor"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="address_row_name colorcodestyle">
                  <input className="form-radio" type="radio" id="[object Object]" name="color" />
                  <label htmlFor="[object Object]" />
                  <span className="name"> Blue</span>
                  <div
                    className="colorcode"
                    style={{
                      backgroundColor: "rgb(144, 184, 197)",
                      border: "1px solid rgb(205, 102, 108)",
                    }}
                  ></div>
                </div>
                <div className="address_row_name colorcodestyle">
                  <input className="form-radio" type="radio" id="[object Object]" name="color" />
                  <label htmlFor="[object Object]" />
                  <span className="name"> Red</span>
                  <div
                    className="colorcode"
                    style={{
                      backgroundColor: "rgb(212, 26, 54)",
                      border: "1px solid rgb(205, 102, 108)",
                    }}
                  />
                </div>
                <div className="address_row_name colorcodestyle">
                  <input className="form-radio" type="radio" id="[object Object]" name="color" />
                  <label htmlFor="[object Object]" />
                  <span className="name"> Purple</span>
                  <div
                    className="colorcode"
                    style={{
                      backgroundColor: "rgb(229, 222, 233)",
                      border: "1px solid rgb(205, 102, 108)",
                    }}
                  ></div>
                </div>
                <div className="address_row_name colorcodestyle">
                  <input className="form-radio" type="radio" id="[object Object]" name="color" />
                  <label htmlFor="[object Object]" />
                  <span className="name"> Starlight</span>
                  <div
                    className="colorcode"
                    style={{
                      backgroundColor: "rgb(252, 247, 244)",
                      border: "1px solid rgb(205, 102, 108)",
                    }}
                  ></div>
                </div>
                <div className="address_row_name colorcodestyle">
                  <input className="form-radio" type="radio" id="[object Object]" name="color" />
                  <label htmlFor="[object Object]" />
                  <span className="name"> Midnight</span>
                  <div
                    className="colorcode"
                    style={{ backgroundColor: "rgb(65, 71, 77)", border: "1px solid rgb(205, 102, 108)" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingstorage">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOnestorage"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                Storage <span className="tempLabel" />
              </button>
            </h2>
            <div
              id="collapseOnestorage"
              className="accordion-collapse"
              aria-labelledby="headingstorage"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="address_row_name">
                  <input className="form-radio" type="radio" name="storage" />
                  <label />
                  <span className="name"> 128 GB</span>
                </div>
                <div className="address_row_name">
                  <input className="form-radio" type="radio" name="storage" />
                  <label />
                  <span className="name"> 256 GB</span>
                </div>
                <div className="address_row_name">
                  <input className="form-radio" type="radio" name="storage" />
                  <label />
                  <span className="name"> 512 GB</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="customfilter d-md-none d-lg-none product-custom-filter">
        <div className="accordion pt-2 pe-5" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header customMobile" id="headingZero">
              <button className="accordion-button" type="button">
                <h4 className="d-flex align-items-center">
                  <img src="" className="pe-2" /> Variants
                </h4>
              </button>
            </h2>
            <div id="collapseZero" className="accordion-collapse">
              <div className="accordion-body">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingsize">
                    <button className="accordion-button" type="button">
                      Display Size
                      <span className="tempLabel" />
                    </button>
                  </h2>
                  <div id="collapseOnesize" className="accordion-collapse">
                    <div className="accordion-body">
                      <div className="address_row_name">
                        <input className="form-radio" type="radio" name="size" />
                        <label />
                        <span className="name"> 6.1-inch</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingcolor">
                    <button className="accordion-button" disabled type="button">
                      Color
                      <span className="tempLabel" />
                    </button>
                  </h2>
                  <div id="collapseOnecolor" className="accordion-collapse">
                    <div className="accordion-body">
                      <div className="address_row_name colorcodestyle">
                        <input className="form-radio" type="radio" id="[object Object]" name="color" />
                        <label htmlFor="[object Object]" />
                        <span className="name"> Blue</span>
                        <div
                          className="colorcode"
                          style={{
                            backgroundColor: "rgb(144, 184, 197)",
                            border: "1px solid rgb(205, 102, 108)",
                          }}
                        ></div>
                      </div>
                      <div className="address_row_name colorcodestyle">
                        <input className="form-radio" type="radio" id="[object Object]" name="color" />
                        <label htmlFor="[object Object]" />
                        <span className="name"> Red</span>
                        <div
                          className="colorcode"
                          style={{
                            backgroundColor: "rgb(212, 26, 54)",
                            border: "1px solid rgb(205, 102, 108)",
                          }}
                        ></div>
                      </div>
                      <div className="address_row_name colorcodestyle">
                        <input className="form-radio" type="radio" id="[object Object]" name="color" />
                        <label htmlFor="[object Object]" />
                        <span className="name"> Purple</span>
                        <div
                          className="colorcode"
                          style={{
                            backgroundColor: "rgb(229, 222, 233)",
                            border: "1px solid rgb(205, 102, 108)",
                          }}
                        ></div>
                      </div>
                      <div className="address_row_name colorcodestyle">
                        <input className="form-radio" type="radio" id="[object Object]" name="color" />
                        <label htmlFor="[object Object]" />
                        <span className="name"> Starlight</span>
                        <div
                          className="colorcode"
                          style={{
                            backgroundColor: "rgb(252, 247, 244)",
                            border: "1px solid rgb(205, 102, 108)",
                          }}
                        ></div>
                      </div>
                      <div className="address_row_name colorcodestyle">
                        <input className="form-radio" type="radio" id="[object Object]" name="color" />
                        <label htmlFor="[object Object]" />
                        <span className="name"> Midnight</span>
                        <div
                          className="colorcode"
                          style={{
                            backgroundColor: "rgb(65, 71, 77)",
                            border: "1px solid rgb(205, 102, 108)",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingstorage">
                    <button className="accordion-button" disabled type="button">
                      Storage
                      <span className="tempLabel" />
                    </button>
                  </h2>
                  <div id="collapseOnestorage" className="accordion-collapse">
                    <div className="accordion-body">
                      <div className="address_row_name">
                        <input className="form-radio" type="radio" name="storage" />
                        <label />
                        <span className="name"> 128 GB</span>
                      </div>
                      <div className="address_row_name">
                        <input className="form-radio" type="radio" name="storage" />
                        <label />
                        <span className="name"> 256 GB</span>
                      </div>
                      <div className="address_row_name">
                        <input className="form-radio" type="radio" name="storage" />
                        <label />
                        <span className="name"> 512 GB</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductFilterCard;
